import {
  DeleteComponentConversionRulesRequest,
  DeleteComponentConversionRulesResponse,
  GetComponentConversionRulesRequest,
  GetComponentConversionRulesResponse,
  UpdateComponentConversionRulesRequest,
  UpdateComponentConversionRulesResponse,
  componentConversionRulesRestResource,
} from ".";
import { useRestResourceHook } from "../use-rest-resource-hook";

export const useGetComponentConversionRules = () =>
  useRestResourceHook<
    GetComponentConversionRulesRequest,
    GetComponentConversionRulesResponse
  >((request) =>
    componentConversionRulesRestResource.getComponentConversionRules(request),
  );

export const useUpdateComponentConversionRules = () =>
  useRestResourceHook<
    UpdateComponentConversionRulesRequest,
    UpdateComponentConversionRulesResponse
  >((request) =>
    componentConversionRulesRestResource.updateComponentConversionRules(
      request,
    ),
  );

export const useDeleteComponentConversionRules = () =>
  useRestResourceHook<
    DeleteComponentConversionRulesRequest,
    DeleteComponentConversionRulesResponse
  >((request) =>
    componentConversionRulesRestResource.deleteComponentConversionRules(
      request,
    ),
  );
